/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HiArrowNarrowLeft } from "react-icons/hi";
import { FaLinkedin } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
import { CiCalendarDate } from "react-icons/ci";
import { PiSquaresFourLight } from "react-icons/pi";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useBrand } from "../../../../Providers/Brand";
import { useStaticData } from "../../../../Providers/Data";

import { Table1 } from "../../../../Components/Tables/Tables";
import { Contentcard } from "../Discover/DashBoard";

export const TableCard = ({ heading, length, headers, rows }) => {
  return (
    <div className="w-full flex-col flex items-center justify-between gap-[20px] px-[40px]">
      <div className=" w-full flex item-start text-[16px] text-[#424242] font-[600] ">
        <p>
          {heading} {`(${length || 0})`}
        </p>
      </div>
      <div className=" w-full ">
        <Table1 headers={headers} rows={rows} cellStyles={undefined} />
      </div>
    </div>
  );
};

export const UnlockedCreatorFull = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);
  const InfluencerID = query?.get("InfluencerID");

  const [UnlockedInfo, SetUnlockedInfo] = useState(null);
  const [InfluencerInfo, SetInfluencerInfo] = useState(null);
  const [InfluencerCollabInfo, SetInfluencerCollabInfo] = useState(null);
  const [InfluencerMonetizationInfo, SetInfluencerMonetizationInfo] =
    useState(null);
  const [InfluencerContentInfo, SetInfluencerContentInfo] = useState(null);
  const [InfluencerAudienceInfo, SetInfluencerAudienceInfo] = useState(null);

  const brandState = useBrand();
  const staticDataState = useStaticData();

  //master data
  const [masterContentCategory, setMasterContentCategory] = useState([]);
  const [, setMasterContentFormat] = useState([]);
  const [masterAudienceTypes, setMasterAudienceTypes] = useState([]);
  const [masterAudiencePlatfroms, setMasterAudiencePlatfroms] = useState([]);
  const [masterCollabGoals, setMasterCollabGoals] = useState([]);
  const [masterMonetizationPlatform, setMasterMonetizationPlatform] = useState(
    []
  );
  const [masterMonetizationServices, setMasterMonetizationServices] = useState(
    []
  );

  useEffect(() => {
    staticDataState?.getNewDataFromType("Content Type").then((e) => {
      setMasterContentCategory(e);
    });
    staticDataState?.getNewDataFromType("Content Format").then((e) => {
      setMasterContentFormat(e);
    });
    staticDataState
      ?.getNewDataFromType("lkd_super_master_audienceType")
      .then((e) => {
        setMasterAudienceTypes(e);
      });
    staticDataState?.getNewDataFromType("Audience Platform").then((e) => {
      setMasterAudiencePlatfroms(e);
    });
    staticDataState?.getNewDataFromType("Goal / KPI").then((e) => {
      setMasterCollabGoals(e);
    });
    staticDataState?.getNewDataFromType("Platform Name").then((e) => {
      setMasterMonetizationPlatform(e);
    });
    staticDataState?.getNewDataFromType("Services list").then((e) => {
      setMasterMonetizationServices(e);
    });
  }, []);

  useEffect(() => {
    async function getInfluencerPersonalInfo() {
      const result = await brandState?.getInfluencerPersonalInfo(InfluencerID);
      if (result.success) {
        result?.unlockedInfo && SetUnlockedInfo(result?.unlockedInfo);
        result?.data && SetInfluencerInfo(result?.data);
        result?.data2 && SetInfluencerCollabInfo(result?.data2);
        result?.data3 && SetInfluencerMonetizationInfo(result?.data3);
        result?.data4 && SetInfluencerContentInfo(result?.data4);
        result?.data5 && SetInfluencerAudienceInfo(result?.data5);
      } else {
        toast.error(result?.Error, { autoClose: 1500 });
        navigate("/Brand/DashBoard/UnlockedInfluencer");
      }
    }
    getInfluencerPersonalInfo();
  }, []);

  const convertToReadableFormat = (number) => {
    if (Math.abs(number) >= 1000000000) {
      return (number / 1000000000).toFixed(1) + "B";
    } else if (Math.abs(number) >= 1000000) {
      return (number / 1000000).toFixed(1) + "M";
    } else if (Math.abs(number) >= 1000) {
      return (number / 1000).toFixed(1) + "K";
    } else {
      return number?.toString();
    }
  };

  const getDate = (date) => {
    const utcDate = new Date(date);

    // Convert UTC time to IST (Indian Standard Time)
    const istDate = new Date(utcDate.getTime());

    // Extract date components
    const day = String(istDate.getDate()).padStart(2, "0");
    const month = String(istDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = istDate.getFullYear();

    // Extract time components
    const hours = String(istDate.getHours()).padStart(2, "0");
    const minutes = String(istDate.getMinutes()).padStart(2, "0");
    const seconds = String(istDate.getSeconds()).padStart(2, "0");

    // Construct the formatted string
    const formattedDateTimeString = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} IST`;
    return formattedDateTimeString;
  };

  return (
    <div className="w-full h-full">
      <div className="flex flex-col w-full h-auto px-[40px] py-[20px] align-left gap-[20px]">
        <p className="flex gap-[12px] text-[18px] font-[600] text-[#424242] ">
          <button
            onClick={() => navigate("/Brand/DashBoard/UnlockedInfluencer")}
          >
            <HiArrowNarrowLeft size={20} />
          </button>
          {"Creator Details"}
        </p>
        <div className="w-full font-inter items-center flex flex-col p-[40px] gap-[20px] bg-[#FAFAFA] rounded-[12px]">
          {/* creater details header */}
          <div className="w-full flex items-center justify-between px-[40px]">
            <div className="flex gap-[16px] items-center justify-center ">
              <img
                className="w-[80px] h-[80px] rounded-[50%] "
                src={
                  InfluencerInfo?.profile ||
                  "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/user.png"
                }
                onError={(e: any) => {
                  e.target.onerror = null; // Remove the event handler to prevent infinite loops
                  e.target.src =
                    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/user.png";
                }}
                alt=""
              />
              <div>
                <p className=" text-[20px] font-[600] text-[#424242] ">
                  {InfluencerInfo?.name}
                </p>
                <p className="flex items-center gap-[4px] text-[16px] text-[#0076B2] font-[400] ">
                  <FaLinkedin color="#0076B2" />{" "}
                  {convertToReadableFormat(InfluencerInfo?.followers?.linkedin)}{" "}
                  Followers
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-[12px]">
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                {" "}
                <CiMail color="#FF5C5C" size={24} />{" "}
                {InfluencerInfo?.email || "Not Available"}
              </p>
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                <IoCallOutline color="#FF5C5C" size={24} />{" "}
                {InfluencerInfo?.mobile || "Not Available"}
              </p>
            </div>
            <div className="flex flex-col gap-[12px]">
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                {" "}
                <CiLocationOn color="#FF5C5C" size={24} /> India
              </p>
              <p className="flex gap-[8px] text-[#424242] text-[16px] ">
                <CiCalendarDate color="#FF5C5C" size={24} /> Unlocked On :
                {getDate(UnlockedInfo?.updatedAt)}
              </p>
            </div>
          </div>

          <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>

          {/* creator collab experience */}
          {InfluencerCollabInfo && (
            <>
              {/* <div className=" w-full px-[40px]  flex item-start text-[16px] text-[#424242] font-[600] ">
                <p>
                  Collab Experience{" "}
                  {`: ${InfluencerCollabInfo?.data?.length || 0}`}
                </p>
              </div> */}
              {/* <div className="flex gap-[9px] w-full px-[40px] flex-wrap">
                {InfluencerCollabInfo?.data?.map((item, index) => {
                  return (
                    <CreatorDetailCard
                      icon={undefined}
                      heading={`${
                        item?.companyName?.toUpperCase() || "Not Available"
                      }`}
                      proofLink={item?.postLink}
                      count={undefined}
                      data={item?.goals}
                      bg={"#EAEBFF"}
                    />
                  );
                })}
              </div> */}
              <TableCard
                heading={"Collab Experience"}
                length={InfluencerCollabInfo?.data?.length}
                headers={[
                  "S. No. ",
                  "Company Name",
                  "Website",
                  "Post Link",
                  "Goals",
                ]}
                rows={InfluencerCollabInfo?.data?.map((item, index) => [
                  index + 1, // S.No.
                  `${item?.companyName || "Not Available"}`,
                  <div
                    onClick={() => {
                      if (!/^https?:\/\//i.test(item?.companyUrl)) {
                        const companyUrl = "https://" + item?.companyUrl;
                        return window.open(companyUrl, "_blank");
                      }

                      window.open(item?.companyUrl, "_blank");
                    }}
                    className="text-[#6183E4] cursor-pointer"
                  >
                    {item?.companyUrl.slice(0, 20) || "Not Available"}
                  </div>,
                  <div
                    onClick={() => {
                      if (!/^https?:\/\//i.test(item?.postLink)) {
                        const postLink = "https://" + item?.postLink;
                        return window.open(postLink, "_blank");
                      }

                      window.open(item?.postLink, "_blank");
                    }}
                    className="text-[#6183E4] cursor-pointer"
                  >
                    {`${item?.postLink?.slice(0, 20) || "Not Available"}...`}
                  </div>,

                  <div className="flex items-center justify-center">
                    {item?.goals?.length > 0
                      ? item?.goals
                          ?.map((goal) => {
                            const GoalName = masterCollabGoals?.find(
                              (mastergoal) => mastergoal?._id === goal
                            );
                            return GoalName?.CollabGoalsName;
                          })
                          ?.map((item) => (
                            <div className="flex px-[12px] mr-[4px] py-[4px] rounded-[198px] bg-[#D1FAE5] align-center justify-center">
                              {item}
                            </div>
                          ))
                      : "Not Available"}
                  </div>,
                ])}
              />
              <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
            </>
          )}

          {/* creator Monetization Avenues*/}
          {InfluencerMonetizationInfo && (
            <>
              {/* <div className=" w-full px-[40px]  flex item-start text-[16px] text-[#424242] font-[600] ">
                <p>
                Monetization Avenues{" "}
                  {`: ${InfluencerMonetizationInfo?.data?.length || 0}`}
                </p>
              </div>
              <div className="flex gap-[9px] w-full px-[40px] flex-wrap">
                {InfluencerMonetizationInfo?.data?.map((item, index) => {
                  return (
                    <CreatorDetailCard
                      icon={platformLogo[0]?.[item?.platformName]}
                      heading={`${
                        item?.platformName?.toUpperCase() || "Not Available"
                      }`}
                      proofLink={item?.profileLink}
                      count={undefined}
                      data={item?.methods}
                      bg={"#FAECFF"}
                    />
                  );
                })}
              </div> */}
              <TableCard
                heading={"Monetization Avenues"}
                length={InfluencerMonetizationInfo?.data?.length}
                headers={[
                  "S. No. ",
                  "Company Name",
                  "Profile Link",
                  "Services",
                  "Paid audience",
                ]}
                rows={InfluencerMonetizationInfo?.data?.map((item, index) => [
                  index + 1,
                  <div>
                    <img
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        marginRight: "12px",
                      }}
                      src={
                        masterMonetizationPlatform?.find(
                          (platform) => platform?._id === item?.platformName
                        )?.monetizationPlatformIcon
                      }
                      alt=""
                    />

                    {masterMonetizationPlatform?.find(
                      (platform) => platform?._id === item?.platformName
                    )?.monetizationPlatformName || "Not Available"}
                  </div>,

                  <div
                    onClick={() => {
                      if (!/^https?:\/\//i.test(item?.profileLink)) {
                        const profileLink = "https://" + item?.profileLink;
                        return window.open(profileLink, "_blank");
                      }

                      window.open(item?.profileLink, "_blank");
                    }}
                    className="text-[#6183E4] cursor-pointer"
                  >
                    {`${item?.profileLink?.slice(0, 20) || "Not Available"}`}
                  </div>,
                  <div>
                    {item?.methods?.length > 0
                      ? item?.methods
                          ?.map((method) => {
                            const methodName = masterMonetizationServices?.find(
                              (mastermethod) => mastermethod?._id === method
                            );
                            return methodName?.monetizationServiceName;
                          })
                          ?.map((item) => (
                            <div className="flex px-[12px] mr-[4px] py-[4px] rounded-[198px] bg-[#D1FAE5] align-center justify-center">
                              {item}
                            </div>
                          ))
                      : "Not Available"}
                  </div>,

                  item?.paidAudience || "Not Available",
                ])}
              />
              <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
            </>
          )}

          {/* Content category */}
          <div className="w-full flex-col flex items-center justify-between gap-[20px] px-[40px]">
            {InfluencerContentInfo && (
              <>
                <Contentcard
                  icon={<PiSquaresFourLight color="#424242" size={18} />}
                  heading={"Content category"}
                  number={InfluencerContentInfo?.categories?.length}
                  type={InfluencerContentInfo?.categories}
                  borderRadius={"198px"}
                  masterData={masterContentCategory}
                  masterItemName={"categoryName"}
                  masterIconName="categoryIcon"
                />
                <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
              </>
            )}
          </div>

          {/* Audience category */}
          <div className="w-full flex-col flex items-center justify-between gap-[20px] px-[40px]">
            {InfluencerAudienceInfo?.types?.length > 0 && (
              <>
                <Contentcard
                  icon={<PiSquaresFourLight color="#424242" size={18} />}
                  heading={"Audience category"}
                  number={InfluencerAudienceInfo?.types?.length}
                  type={InfluencerAudienceInfo?.types}
                  borderRadius={"198px"}
                  masterData={masterAudienceTypes}
                  masterItemName={"LkdAudienceTypeName"}
                  // masterIconName="audienceTypeIcon"
                />
                <div className="w-[95%] h-[1px] bg-[#EEEEEE]"></div>
              </>
            )}
          </div>

          {/* Audience Presence */}
          {InfluencerAudienceInfo?.platforms?.length > 0 && (
            <TableCard
              heading={"Audience Presence"}
              length={InfluencerAudienceInfo?.platforms?.reduce(
                (total, platform) => total + platform.audience,
                0
              )}
              headers={["S. No. ", "Platform Names", "No. of users", "Link"]}
              rows={InfluencerAudienceInfo?.platforms
                ?.filter((item) => {
                  return masterAudiencePlatfroms?.find(
                    (platform) => platform?._id === item?.platform
                  )?.audiencePlatformName;
                })
                ?.map((item, index) => [
                  index + 1,
                  <div>
                    <img
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        marginRight: "12px",
                      }}
                      src={
                        masterAudiencePlatfroms?.find(
                          (platform) => platform?._id === item?.platform
                        )?.audiencePlatformIcon
                      }
                      alt=""
                    />

                    {masterAudiencePlatfroms?.find(
                      (platform) => platform?._id === item?.platform
                    )?.audiencePlatformName || "Not Available"}
                  </div>,

                  item?.audience || "Not Available",
                  <div
                    onClick={() => {
                      if (!/^https?:\/\//i.test(item?.link)) {
                        const link = "https://" + item?.link;
                        return window.open(link, "_blank");
                      }

                      window.open(item?.link, "_blank");
                    }}
                    className="text-[#6183E4] cursor-pointer"
                  >
                    {`${item?.link?.slice(0, 25) || "Not Available"}`}
                  </div>,
                ])}
            />
          )}
        </div>
      </div>
    </div>
  );
};
